import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getProposalValidation } from '../../store/actions/proposalActions';
import ProposalList from '../../components/proposal';
import { formatDateUS, toaster } from '../../utils/utils';

const seedData = [
  {
    name: 'Policy No.',
    value: '',
    key: 'policyNo',
    show: true,
  },
  {
    name: 'Proposer Name',
    value: '',
    key: 'proposerName',
    show: true,
  },
  {
    name: 'Insured Name',
    value: '',
    key: 'insuredName',
    show: true,
  },
  {
    name: 'SB Amount',
    value: '',
    key: 'sbAmount',
    show: true,
  },
  {
    name: 'Policy Status',
    value: '',
    key: 'policyStatus',
    show: true,
  },
  {
    name: 'SB Payment Due date (MM/DD/YYYY)',
    value: '',
    key: 'sbPaymentDueDate',
    show: true,
  },
  {
    name: 'Last Payout date (MM/DD/YYYY)',
    value: '',
    key: 'lastPayoutDate',
    show: true,
  },
];

const BlueChip = () => {
  const [proposalData, setProposalData] = useState({
    policyNumber: '',
    error: false,
  });
  const [isProposalTableShow, setIsProposalTableShow] = useState(false);
  const [validationApiResponse, setValidationApiResponse] = useState({});
  const dispatch = useDispatch();

  const [initialdata, setData] = useState(seedData);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!proposalData.policyNumber) {
      setProposalData({ error: true });
      return;
    }
    const param = {
      policyNumber: proposalData.policyNumber,
    };
    dispatch(
      getProposalValidation(param, (resp) => {
        if (resp?.body) {
          let data;
          let respBody = resp.body;
          data = seedData.map((item) => {
            if (respBody[item.key]) {
              if (
                item.key === 'sbPaymentDueDate' ||
                item.key === 'lastPayoutDate'
              ) {
                item.value = formatDateUS(respBody[item.key]);
              } else {
                item.value = respBody[item.key];
              }
            }
            return item;
          });
          setData(data);
          setIsProposalTableShow(true);
        } else {
          setData([]);
          setIsProposalTableShow(false);
        }
        toaster(resp?.messageType, resp?.message);
        setValidationApiResponse(resp);
      })
    );
  };

  const inputHandler = (e) => {
    if (e.target.value === '') {
      setValidationApiResponse({});
      setData([]);
      setIsProposalTableShow(false);
    }
    setProposalData({ policyNumber: e.target.value, error: false });
  };

  const handleClear = (e) => {
    e.preventDefault();
    setProposalData({ policyNumber: '', error: false });
    setIsProposalTableShow(false);
    setValidationApiResponse({});
  };

  return (
    <div className='proposalDetails_comp'>
      <form>
        <p>Enter Policy Number</p>
        <div className='input-fields-wrapper'>
          <input
            onChange={(e) => inputHandler(e, 'policyno')}
            value={proposalData.policyNumber}
            className={`input-field`}
            type='text'
            placeholder='Enter Policy Number'
            name='policy'
          />
        </div>
        {proposalData.error && (
          <div className='error'>Please Enter Policy Number</div>
        )}
        <button className='searchbt' onClick={handleSubmit}>
          Submit
        </button>
        <button className='searchbt ms-2' onClick={handleClear}>
          Clear
        </button>
        {proposalData.policyNumber &&
          validationApiResponse &&
          validationApiResponse?.messageType && (
            <div className={validationApiResponse?.messageType}>
              {validationApiResponse?.message}
            </div>
          )}
      </form>

      {isProposalTableShow && (
        <div className='main_container'>
          <ProposalList initialdata={initialdata} proposalData={initialdata} />
        </div>
      )}
    </div>
  );
};

export default BlueChip;
